export default __webpack_public_path__ + "static/media/logo.051e4890.png";